export const BILLING_TOPUP_SIGNAL_KEY = "lotlocator:billing-topup-complete";
export const BILLING_TOPUP_AUTH_KEY = "lotlocator:billing-topup-auth";
